export default __webpack_public_path__ + "static/media/century_751_semi_bold.1f162afa.ttf";